import { isAxiosError } from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getShiftListAll } from "../../../axios/Shift/ShiftApi";
import { getUserList, getUserListAll } from "../../../axios/User/UserApi";
import { useAuth } from "../../../context/AuthContext";
import { LoadingProvider, useLoading } from "../../../context/LoadingContext";
import EventLogInfo from "./EventLogInfo";
import EventLogTabs from "./EventLogTabs";
import DeviceApi from "../../../axios/Device/DeviceApi";
import { getListGroup } from "../../../axios/Group/GroupUrlApi";
import {
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  getDay,
  startOfWeek,
  format
} from 'date-fns';
import { useRefresh } from "../../../context/RefreshContext";

const EventLog = () => {
  const { refreshData, handleRefreshData } = useRefresh();
  const { isAdmin, profile } = useAuth();
  const { getDeviceList } = DeviceApi();
  const { state } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [show, hide] = useLoading();
  const { t, i18n } = useTranslation();
  const [selectedRows, setSelectedRows] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedShift, setSelectedShift] = useState(0);
  const [selectDevice, setSelectedDevice] = useState(0);
  const [selectGroup, setSelectedGroup] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [usersData, setUsersData] = useState([]);
  const [shiftsData, setShiftsData] = useState([]);
  const [shiftsDataNoAllShift, setShiftsDataNoAllShift] = useState([]);
  const [devicesData, setDevicesData] = useState([]);
  const [isShowErrorLog, setIsShowErrorLog] = useState(false);
  const [isShowEnableLog,] = useState(true);
  const [isShowErrorIMG, setIsShowErrorIMG] = useState(true);
  const [error, setError] = useState(null);
  const [tabName, setTabName] = useState(0);
  const [selectStartTime, setSelectStartTime] = useState("00:00:00");
  const [selectEndTime, setSelectEndTime] = useState("23:59:00");
  // localStorage.removeItem("redirectAfterLogin");
  const [groupData, setGroupData] = useState([]);
  // const [errorUserIds, setErrorUserIds] = useState([]);
  const [dispalyWeek, setDispalyWeek] = useState(0);
  const currentLang = i18n.language;
  const dialogRef = useRef(null);

  const [errorUserIds, setErrorUserIds] = useState({
    missingCheckInUserIds: [],
    missingCheckOutUserIds: [],
  });

  const [formatEventFilter, setFormatEventFilter] = useState({});
  const handleGetDataFilterEvent = (data) => {
    setFormatEventFilter(data);
  };

  const handleErrorUsersChange = ({
    missingCheckInUserIds,
    missingCheckOutUserIds,
  }) => {
    setErrorUserIds({
      missingCheckInUserIds: missingCheckInUserIds || [],
      missingCheckOutUserIds: missingCheckOutUserIds || [],
    });
  };

  useEffect(() => {
    const fetchShift = async () => {
      try {
        show();
        const response = await getShiftListAll(
          localStorage.getItem("i18nextLngId")
        );
        const shiftList = response.data.listShift;
        setShiftsDataNoAllShift(response.data.listShift);
        const modifiedShiftsList = [
          { shiftId: 0, shiftName: "All shift" },
          ...shiftList,
        ];
        // const modifiedShiftsList = [...shiftList, { shiftId: 0, shiftName: 'All shift' }];
        setShiftsData(modifiedShiftsList);
      } catch (error) {
        setError(error);
      } finally {
        hide();
      }
    };

    const fetchDevice = async () => {
      try {
        show();
        const response = await getDeviceList(
          {
            pageNo: 1,
            recordPerPage: 500
          },
          localStorage.getItem("i18nextLngId")
        );
        const deviceList = response.data.listDevice;
        // setShiftsData(response.data.listShift);
        const modifiedDeviceList = [
          { deviceId: 0, description: "All Device" },
          ...deviceList,
        ];
        setDevicesData(modifiedDeviceList);
      } catch (error) {
        setError(error);
      } finally {
        hide();
      }
    };

    const fetchUser = async () => {
      try {
        show();
        const payload = {
          statusId: 1,
          page: 1,
          pageSize: 1000,
          status: null,
          langId: localStorage.getItem("i18nextLngId"),
        };
        const response = await getUserList(payload);
        // const response = await getUserListAll();
        const usersList = response.data.data;
        // setSelectedUser(usersList?.find((v) => v.userId === (state?.userId || profile.userId)));
        setSelectedUser(
          state?.userId
            ? usersList?.find((v) => v.userId === state.userId)
            : null
        );

        setUsersData(usersList);
      } catch (error) {
        setError(error);
      } finally {
        hide();
      }
    };

    fetchShift();
    if (isAdmin) {
      fetchUser();
      fetchDevice();
    }
  }, [hide, show, t, isAdmin, state, profile]);

  const fetchData = async () => {
    const payload = {
      pageNo: 1,
      recordPerPage: 500,
      langId: localStorage.getItem("i18nextLngId"),
    };
    try {
      const response = await getListGroup(payload);
      if (response.data.data.length > 0) {
        const listUserGroup = response.data.data;
        setGroupData(listUserGroup);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (error && isAxiosError(error)) {
      toast.error(t(error.response.data));
    }
  }, [error, t]);

  function getTabName(data) {
    setTabName(data);
  }

  const calculateDisplayedWeeks = (date, weekStartsOnAbbr) => {
    let weekDayAbbrToIndex = {}
    if (currentLang === 'vi') {
      weekDayAbbrToIndex = {
        CN: 0,
        T2: 1,
        T3: 2,
        T4: 3,
        T5: 4,
        T6: 5,
        T7: 6,
      };
    } else {
      weekDayAbbrToIndex = {
        Sun: 0,
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6,
      };
    }

    const weekStartsOn = weekDayAbbrToIndex[weekStartsOnAbbr];
    if (weekStartsOn === undefined) {
      throw new Error("Invalid week start day. Use 'Sun', 'Mon', 'Tue', etc.");
    }

    const firstDayOfMonth = startOfMonth(date);
    const lastDayOfMonth = endOfMonth(date);

    const calendarStartDate = startOfWeek(firstDayOfMonth, { weekStartsOn });

    const daysInGrid = eachDayOfInterval({
      start: calendarStartDate,
      end: lastDayOfMonth,
    });

    const totalCells = daysInGrid.length <= 35 ? 35 : 42;
    setDispalyWeek(totalCells / 7)
    return totalCells / 7;
  };

  return (
    <div className="event-log">
      <div className="card min-w-0">
        <LoadingProvider>
          <EventLogTabs
            isShowErrorLog={isShowErrorLog}
            isShowEnableLog={isShowEnableLog}
            isShowErrorIMG={isShowErrorIMG}
            selectedDate={selectedDate}
            selectedShift={selectedShift}
            selectDevice={selectDevice}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            setSelectedDate={setSelectedDate}
            setSelectedShift={setSelectedShift}
            setSelectedDevice={setSelectedDevice}
            setSelectedGroup={setSelectedGroup}
            setIsShowErrorLog={setIsShowErrorLog}
            setIsShowErrorIMG={setIsShowErrorIMG}
            refreshData={refreshData}
            onRefresh={handleRefreshData}
            onRowSelection={setSelectedRows}
            getTabName={getTabName}
            usersData={usersData}
            selectStartTime={selectStartTime}
            selectEndTime={selectEndTime}
            setSelectStartTime={setSelectStartTime}
            setSelectEndTime={setSelectEndTime}
            formatEventFilter={formatEventFilter}
            onErrorUsersChange={handleErrorUsersChange}
            errorUserIds={errorUserIds}
            selectGroup={selectGroup}
            dispalyWeek={dispalyWeek}
            groupData={groupData}
            shiftsData={shiftsData}
            devicesData={devicesData}
            dialogRef={dialogRef}
            calculateDisplayedWeeks={calculateDisplayedWeeks}
          />
        </LoadingProvider>
      </div>

      <EventLogInfo
        ref={dialogRef}
        dialogOnly
        info={selectedRows}
        selectedDate={selectedDate}
        selectedShift={selectedShift}
        selectDevice={selectDevice}
        selectedUser={selectedUser}
        usersData={usersData}
        shiftsData={shiftsData}
        groupData={groupData}
        setSelectedDate={setSelectedDate}
        setIsShowErrorLog={setIsShowErrorLog}
        setIsShowErrorIMG={setIsShowErrorIMG}
        isShowErrorIMG={isShowErrorIMG}
        setSelectedShift={setSelectedShift}
        setSelectedDevice={setSelectedDevice}
        setSelectedUser={setSelectedUser}
        onRefresh={handleRefreshData}
        refreshData={refreshData}
        tabName={tabName}
        devicesData={devicesData}
        shiftsDataNoAllShift={shiftsDataNoAllShift}
        setSelectStartTime={setSelectStartTime}
        selectStartTime={selectStartTime}
        setSelectEndTime={setSelectEndTime}
        selectEndTime={selectEndTime}
        setSelectedGroup={setSelectedGroup}
        handleGetDataFilterEvent={handleGetDataFilterEvent}
        errorUserIds={errorUserIds}
        calculateDisplayedWeeks={calculateDisplayedWeeks}
        selectGroup={selectGroup}
      />
    </div>
  );
};

export default EventLog;
